// extracted by mini-css-extract-plugin
module.exports = {"AddProposalOption":"styles_AddProposalOption__VxHKA"};